// src/components/Settings/MultiChoiceToggle.js

import React from 'react';

const MultiChoiceToggle = ({ forceMultiChoice, setForceMultiChoice }) => (
    <div>
        <button onClick={() => setForceMultiChoice(!forceMultiChoice)}>
            {forceMultiChoice
                ? 'Przełącz na tryb Automatyczny (radio/checkbox)'
                : 'Przełącz na tryb Zawsze wielokrotny (checkbox)'
            }
        </button>
        <p style={{ marginTop: 5 }}>
            Aktualny tryb pytań:
            {forceMultiChoice
                ? 'Tryb: zawsze wielokrotny wybór (checkboxy)'
                : 'Tryb: automatyczny (radio lub checkbox w zależności od pytania)'
            }
        </p>
    </div>
);

export default MultiChoiceToggle;
